export const DATA = {
    AssessmentEntityName: 'First Abu Dhabi Bank (FAB)',
    AssessmentName: 'Credit Risk Assessment',
    ActionPlanID: 'AP-000848',
    ActionPlanNameArabic: 'تطبيق إطار عمل مخاطر الائتمان القائم على النظام',
    ActionPlanName: 'Implement a system-based credit risk framework',
    ActionPlanStartDate: '20.07.2023',
    ActionPlanTargetDate: '20.07.2023',
    ActionPlanDescription:
        'Credit Risk - Implement a system-based credit risk framework in your organization',
    ActionPlanDescriptionArabic:
        'مخاطر الائتمان - تطبيق إطار عمل مخاطر الائتمان القائم على النظام في مؤسستك',
    ActionItems: [
        {
            SerialNumber: 1,
            ActionItemID: 'AP-000001',
            ActionItemName:
                'Send out RFP of the detailed credit risk framework to be implemented',
            ActionItemNameArabic:
                'مخاطر الائتمان - إرسال طلب عرض (RFP) لإطار عمل مخاطر الائتمان التفصيلي ليتم تنفيذه',
            ActionItemStartDate: '20.07.2023',
            ActionItemTargetDate: '31.07.2023',
            Criticality: 'High',
            ActionItemCategory: 'Procedure',
            ActualCompletionDate: '25.07.2023',
            ActionItemStatus: 'Under Review',
            ActionItemDescription:
                'Send out RFP of the detailed credit risk framework to be implemented',
            ActionItemDescriptionArabic:
                'مخاطر الائتمان - إرسال طلب عرض (RFP) لإطار عمل مخاطر الائتمان التفصيلي ليتم تنفيذه',
            CommentsHistory:
                '25.07.2023 – Rafiq Ahmad: Request for proposal have been released, enclosed in email for your reference.',
        },
    ],
};
